import React from 'react';
import { Link } from 'react-router-dom';
import { PageHero } from '../components/PageHero';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { BuildingIcon, LandmarkIcon, GraduationCapIcon, ChurchIcon, MusicIcon, MegaphoneIcon, BriefcaseIcon } from 'lucide-react';
export function IndustriesPage() {
  useScrollReveal();
  const industries = [{
    icon: BriefcaseIcon,
    title: 'Corporate',
    desc: "From annual general meetings and board conferences to gala dinners and end-of-year functions, we provide polished, reliable AV solutions that reflect your corporate brand's professionalism."
  }, {
    icon: LandmarkIcon,
    title: 'Government',
    desc: 'Trusted by public sector departments for official ceremonies, national day celebrations, and high-level summits requiring strict protocols, secure setups, and flawless execution.'
  }, {
    icon: GraduationCapIcon,
    title: 'Education',
    desc: 'Supporting schools, colleges, and universities with sound and staging for graduations, sports days, theatrical productions, and academic conferences.'
  }, {
    icon: ChurchIcon,
    title: 'Worship',
    desc: 'Enhancing the worship experience with clear audio reinforcement, dynamic lighting, and visual displays for weekly services, revivals, and large-scale religious gatherings.'
  }, {
    icon: MusicIcon,
    title: 'Entertainment',
    desc: 'Delivering high-impact production for live concerts, music festivals, beauty pageants, and theatrical shows where technical performance makes or breaks the audience experience.'
  }, {
    icon: MegaphoneIcon,
    title: 'Promotions',
    desc: 'Creating engaging technical environments for product launches, brand activations, mall promotions, and roadshows that capture attention and drive engagement.'
  }];
  return <main className="w-full" data-id="element-420">
      <PageHero title="Industries We Serve" subtitle="Tailored technical solutions for diverse sectors across Botswana." icon={BuildingIcon} data-id="element-421" />

      <section className="py-20 px-6 bg-brand-black" data-id="element-422">
        <div className="max-w-7xl mx-auto" data-id="element-423">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-424">
            {industries.map((industry, index) => <div key={index} className="glass-card p-10 reveal" style={{
            transitionDelay: `${index * 100}ms`
          }} data-id="element-425">
                <div className="w-16 h-16 rounded-2xl bg-brand-charcoal flex items-center justify-center mb-8 border border-white/10 shadow-inner" data-id="element-426">
                  <industry.icon className="w-8 h-8 text-brand-cyan" data-id="element-427" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-4" data-id="element-428">
                  {industry.title}
                </h3>
                <p className="text-brand-muted-light leading-relaxed" data-id="element-429">
                  {industry.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-20 px-6 bg-brand-charcoal text-center reveal border-t border-white/5" data-id="element-430">
        <div className="max-w-3xl mx-auto" data-id="element-431">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-432">
            Don't see your industry?
          </h2>
          <p className="text-brand-muted-light mb-8 text-lg" data-id="element-433">
            Our technical expertise is adaptable to almost any environment or
            event type.
          </p>
          <Link to="/contact" className="btn-glow" data-id="element-434">
            Contact Us Today
          </Link>
        </div>
      </section>
    </main>;
}